
<template>
  <div class="product-newbox" v-if="data">
    <div
      class="p-detail-new nomargin"
      v-for="(item, index) in data.details"
      :class="{
        'expanded': !item.expanded,
        'page-image': pageTypeImage,
        'first': index === 0
      }"
    >
      <div class="p-title-box">
        <div class="title-box" @click="toggleDetail">
          <div class="title">{{item.title}}</div>
          <div v-if="!item._spreadAll" class="arrow arrow-down"></div>
        </div>
        <div
          class="content-box"
          :style="'display:' + (pageTypeImage || index === 0 || item.expanded ? 'block': 'none')"
        >
          <!-- <div class="p-detail-tit">
            <div class="p-e-tit">{{ item.titleEn || '' }}</div>
            <div class="p-z-tit">{{ item.title || '' }}</div>
          </div>-->
          <div class="p-detail-content" v-for="(modules, index) in item.modules">
            <div class="p-child-content" v-if="modules.type=='TEXT'">
              <div class="p-child-tit" v-html="formatHtml(modules.title)"></div>
            </div>

            <div
              class="p-text"
              v-if="(modules.type !== 'LINK') && modules.text"
              v-html="formatHtml(modules.text)"
            >
              <!-- {{unescape(modules.text) | formatHtml}} -->
            </div>
            <!-- <div class="p-thh" v-if="item.title === '退换货说明'">
              退换货详情请阅读<a href="/ruler/thh"><<退换货流程>></a>
            </div>-->

            <div
              :class="{
              'p-img':true,
              'no-margin':noMargin(index, data.imageMargin, item.modules)   //如果上一张图片没有描述，则清楚图片间间隔
              }"
              v-if="modules.image"
            >
              <beast-image
                :src="modules.image.src"
                :width="modules.image.width"
                :height="modules.image.height"
              />
              <!-- <img :src="modules.image.src" :width="modules.image.width" :height="modules.image.height" /> -->
              <p v-if="modules.desc && modules.desc!=''" class="p-img-desc">{{ modules.desc || '' }}</p>
            </div>

            <div class="p-variant" v-if="modules.type=='TABLE'" v-for="table in modules.table">
              <div class="p-variant-name">{{ table.tableRow[0] }}</div>
              <div class="p-variant-info" :class="{'fixed-variant': pageTypeImage}">
                <p v-html="unescape(table.tableRow[1])"></p>
              </div>
            </div>
            <div class="p-brand-wrap">
              <div class="p-brand-index" v-if="!pageTypeImage && modules.type=='LINK'">
                <a :href="modules.link | formatLink">{{modules.text}}</a>
                <i></i>
              </div>
            </div>
          </div>
          <!-- <div class="split-line"></div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// test
import browser from "@beastshop/browser";
import beastImage from "@/components/image/";

import { getLink } from "@/components/app-menu/util";

const isApp = browser.app();

export default {
  components: {
    beastImage
  },

  props: {
    data: {
      type: Object
    },
    pageTypeImage: Boolean
  },

  data() {
    return {
      isApp: isApp,
      isHide: true
    };
  },

  methods: {
    unescape(str) {
      return str.replace(/\\n/gi, "<br/>");
    },

    formatHtml(text) {
      const reTag = /<(?:.|\s)*?>/g;
      const styleAttr = /style="[^"]*"/g;
      const remoeveTable = /<table[^>]*>[\s\S]*?<\/table>/g;

      if (!text) return text;

      let content = text.replace(styleAttr, "").replace(remoeveTable, "");

      // return content.replace(/[\n\r]/gi, "<br/>");
      return content.replace(/\r\n/gi, "<br/>");
    },

    toggleDetail(e) {
      const tar = e.currentTarget;
      const arrow = tar.querySelector(".arrow");
      const box = tar.nextElementSibling;
      const isHide = box.style.display === "block" ? true : false;

      arrow.classList.remove("arrow-up", "arrow-down");

      if (isHide) {
        arrow.classList.add("arrow-down");
      } else {
        arrow.classList.add("arrow-up");
      }

      box.style.display = isHide ? "none" : "block";
    },
    noMargin(index, imageMargin, modules) {
      //判断逻辑：栏目imageMargin标记为false，当前模块是图片，有上一个模块，上一个模块是图片，上一个模块没有图片描述，则追加‘no-margin’样式
      if (!imageMargin && modules && modules[index].type == "IMAGE" && modules[index-1] && modules[index-1].type == "IMAGE" && !modules[index-1].desc) {  
        console.log(imageMargin)      
        return "no-margin";
      }
    }
  },

  filters: {
    formatLink(link) {
      if (isApp) {
        return link;
      }

      return getLink(link);
    }
  }
};
</script>



// WEBPACK FOOTER //
// desc-new.vue?117d4f30